import to from "await-to-js";
import axios, { AxiosResponse } from "axios";
import { IEventDispatcher } from "../events";

export type IRequestParams = any

export interface IResultContent{
    is_ok:boolean
    errCode?:string
    errMsg?:string
    html?:string
    msg?:string
}

export interface IResult<T extends IResultContent>{
    data:T
    is_ok:boolean
    is_complate:boolean
    errCode?:string
    errMsg?:string
    html?:string
}
export interface IRequestResult<T extends IResultContent, U extends IRequestParams>{
    response?:AxiosResponse<IResult<T>>
    shellData?:IResult<T>
    err?:Error 
    data?:T
    dataIsOk:boolean
    shellIsOk:boolean
    requestIsOk:boolean
    params?:U

}

export function createDefRequestResult<T extends IResultContent, U extends IRequestParams>():IRequestResult<T, U>{
    return {response:undefined, shellData:undefined, err:undefined, data:undefined, dataIsOk:false, shellIsOk:false, requestIsOk:false, params:undefined}
}
export interface IMember{
    name:string
    team?:string
    gateway?:string
}
export interface ITeam{
    name:string
    gateway?:string
    members:IMember[]
}
export interface ITeamGroup{
    gateway:string
    teams:ITeam[]
}
export interface ITeamGroupMap{
    [key:string]:ITeamGroup
    def:ITeamGroup
}
export const teamGroupMap:ITeamGroupMap = {
    def:{teams:[],gateway:''},
}

export function updateTeamGroupMap(teamGroupMap:ITeamGroupMap) {
    for(const group of Object.values(teamGroupMap)) {
        for(const team of group.teams) {
            for(const member of team.members) {
                endpointMap.set(createEndpoint(group.gateway, team.name, member.name), `${member.gateway ||group.gateway}/${member.team ||team.name}/${member.name}`)
            }
        }
    }
}

function createEndpoint(gateway:string, team:string, member:string) {
    return `${gateway}${team}/${member}`
}

export const endpointMap:Map<string, string> = new Map()

export type RetryDelayType = (count:number, error:Error, gateway:string, team:string, member:string, params:any) => Promise<boolean>


async function retryDelay(count:number, error:Error, info:any, gateway:string, team:string, member:string, params:any) {
    if(count > 5) return false
    await new Promise(resolve => setTimeout(resolve, 1000 * count))
    return true;
}
function getEndpoint(gateway:string, team:string, member:string) {
    const endpoint = createEndpoint(gateway, team, member)
    return endpointMap.get(endpoint) || endpoint
}

export interface IRequestErrorReturnData<U = any>{
    retry:boolean
    delay:number
    // if need to modify the request params
    params?:U
}
export interface IRequestConf<T extends IResultContent, U = any>{
    team:string
    member:string
    gateway?:string
    endpoint:string
    requestHandler?:IRequestHandler<T, U>
}

async function retryFun(delay:number) {
    await new Promise(resolve => setTimeout(resolve, delay))
}
export interface IRequestHandler<T extends IResultContent, U extends IRequestParams>{
    dispatcher?:IEventDispatcher
    onError?:{
        handler:(err?:Error, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>IRequestErrorReturnData<U>
        dispatcher?:IEventDispatcher
        event?:string
    }
    onNetError?:{
        handler:(err?:Error, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>IRequestErrorReturnData<U>
        dispatcher?:IEventDispatcher
        event?:string
    }
    onDataError?:{
        handler?:(err?:Error, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>IRequestErrorReturnData<U>
        dispatcher?:IEventDispatcher
        event?:string
    }
    onResponseError?:{
        handler?:(err?:Error, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>IRequestErrorReturnData<U>
        dispatcher?:IEventDispatcher
        event?:string
    }
    // if shell data is not ok, can set retry 
    onResultNotOk?:{
        handler?:(result?:IResult<T>, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>IRequestErrorReturnData<U>
        dispatcher?:IEventDispatcher
        event?:string
    }
    onResult?:{
        handler?:(data?:T, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>void
        dispatcher?:IEventDispatcher
        event?:string
    }
    // if data is not ok, can set retry
    onDataNotOk?:{
        handler?:(data?:T, result?:IResult<T>, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>IRequestErrorReturnData<U>
        dispatcher?:IEventDispatcher
        event?:string
    }
    onData?:{
        handler?:(data?:T, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>void
        dispatcher?:IEventDispatcher
        event?:string
    }
    onResponse?:{
        handler?:(result:IResult<T>, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>void
        dispatcher?:IEventDispatcher
        event?:string
    }
    onComplete?:{
        handler?:(err?:Error, result?:IResult<T>, response?:AxiosResponse<IResult<T>, U>, handler?:IRequestHandler<T, U>)=>void
        dispatcher?:IEventDispatcher
        event?:string
    }
    retryCount?:number
    maxRetryCount?:number
    retryHandler?:typeof retryFun
    printLog?:boolean
}
export let requestStaticData:{
    userToken?:string
    deviceToken:string
} = {
    userToken:undefined,
    deviceToken:''
}
function getHeader(gateway:string, team:string, member:string, params:any){
    return {"User-Token": requestStaticData.userToken || '', 
        "Device-Token": requestStaticData.deviceToken
        
    }
}
export async function request<T extends IResultContent, U = IRequestParams>(team:string, member:string, params:U, gateway?:string, handler?:IRequestHandler<T, U>):Promise<IRequestResult<T, U>> {
    handler = handler || {}
    handler.retryCount = 0
    handler.maxRetryCount = handler.maxRetryCount || 2
    const endpoint = `${getEndpoint(gateway || teamGroupMap.def.gateway, team, member)}`
    async function handleRetry(event?:string, dispatcher?:IEventDispatcher, err?:Error|null, response?:AxiosResponse<IResult<T>>, r?:IRequestErrorReturnData<U>) {
        if(event && dispatcher){
            dispatcher.dispatchArgs(event, err, response, r)
        }
        handler!.retryCount!++
        if(handler!.retryCount! > handler!.maxRetryCount!)return false
        if(!r){
            await (handler!.retryHandler || retryFun)(handler!.retryCount! * 1000 * 1)
            return true
        }
        if(!r.retry)return false
        await (handler?.retryHandler || retryFun)(r.delay)
        params = r.params || params
        return true
    }

    while(true){
        const res = createDefRequestResult<T, U>()
        res.params = params
        axios.defaults.withCredentials = true
        let [err, response] = await to(axios.post<IResult<T>>(endpoint, params, {headers:getHeader(gateway || teamGroupMap.def.gateway, team, member, params)}))
        if (err)res.err = err
        if(handler.printLog){
            console.log('sendRequest1111111111', endpoint, err, response)
        }
        res.response = response
        if(err){
            if(await handleRetry(handler.onError?.event, handler.onError?.dispatcher, err, response, handler.onError?.handler?.(err, response, handler)))continue; else return res
        }
        if(!response){
            if(await handleRetry(undefined))continue; else return res
        }
        if(response.status != 200){
            if(await handleRetry(handler.onResponseError?.event, handler.onResponseError?.dispatcher || handler.dispatcher, err, response, handler.onResponseError?.handler?.(err || undefined, response, handler)))continue; else return res
        }
        if(!response.data.is_ok){
            if(await handleRetry(handler.onResultNotOk?.event, handler.onResultNotOk?.dispatcher || handler.dispatcher, err, response, handler.onResultNotOk?.handler?.(response.data, response, handler)))continue; else return res
        }
        res.shellData = response.data
        res.shellIsOk = true

        if(!response.data.data.is_ok){
            if(await handleRetry(handler.onDataNotOk?.event, handler.onDataNotOk?.dispatcher || handler.dispatcher, err, response, handler.onDataNotOk?.handler?.(response.data.data, response.data,  response, handler)))continue; else return res
        }
        res.data = response.data.data
        res.dataIsOk = true

        handler.onData?.handler?.(response.data.data, response, handler);

        (handler.onData?.event && (handler.onData.dispatcher || handler.dispatcher)?.dispatchArgs(handler.onData.event, response.data.data, response));

        handler.onResponse?.handler?.(response.data, response, handler);

        (handler.onResponse?.event && (handler.onResponse.dispatcher || handler.dispatcher)?.dispatchArgs(handler.onResponse.event, response.data, response));

        return res
    }

}

// is_ok有两层，第一层是表示服务是否正常，第二层是表示具体业务是否按预期完成。
// {is_ok:true,data:{is_ok:true}}
// 如果是要请求某个人的用户信息
// 第一层的is_ok表示接口存在，第二层的is_ok表示接口可以被调用，如果这个请求没有权限则会返回false。

// 因为axios返回的也叫data，所以在axios中的层级是result.data = axios返回的第一层数据
// result.data.is_ok表示接口存在
// result.data.data.is_ok表示接口按预期走完了流程